﻿window.cObjetArticleMetier = function (objet) {
    var Me = this;
    this.data = objet.data;
    this.objet = objet;

    this.mGetLibBase = function () { return "article"; }
    this.mGetAttributBase = function () { return "l'" }
    this.mGetNewLib = function () { return "Nouvel article"; }
    this.mGetLib1 = function (option) {
        var txt = ""
        if (typeof objet.data != 'undefined' && objet.data.nom != null && objet.data.nom.length > 0) { txt = objet.data.nom }
        else {
            var txt = "..."
        }
        if (typeof option != 'undefined' && typeof option.callBack != 'undefined') { option.callBack(txt) }
        else { return txt }
    }
    this.mGetLib2 = function () {
        return ""
    }

    this.mGetRadiusImage = function () { return "0" }
    this.mGetResume = function () {
        var txt = "";
        return txt;
    }

    this.mGetIcone = function (dataTemplate) {
        return $("<i class='fas fa-barcode' class='Article'></i>");
    }

    this.mGetItemTemplateHeight = function (type) {
        return ((type == "Détails") ? 50 : 40)
    }

    this.contentTemplateGrid = function (contentElement, option) {
        contentElement.empty();
    }

    this.isPopupFullScreen = false
    //this.mShowPopup = function (option) {
    //    if (typeof option == 'undefined') option = {}
    //    option.fullScreen = false
    //    page.mAddPopup(objet.data, option)
    //}
    this.contentTemplatePopup = function (contentElement, option) {
        contentElement.empty();
        contentElement.css("padding", "5px 25px 25px 25px")
        var dxScroll = $("<div/>").appendTo(contentElement).dxScrollView({}).dxScrollView("instance")

        var items = [];
        items.push({
            itemType: "group", name: "grptot",
            caption: " ",
            items: [{
                caption: "",
                template: function (itemData, itemElement) {
                    $("<div style='width:100%;height:100%;'/>").appendTo(itemElement).dxCtrlImageData({
                        bddCtrl: Me.objet.bddRef,
                        size: 180,
                        data: objet.data,
                        allowClick: true,
                        allowDisplayIcone: true
                    }).dxCtrlImageData("instance");
                }
            }],
            colSpanXs: 6, colSpanSm: 6, colSpanMd: 6, colSpanLg: 6
        })

        var itemsAdr = [{
            dataField: "nom", name: "nom", label: { visible: false, text: "Nom", location: "left" },
            template: function (itemData, itemElement) {
                $("<div/>").appendTo(itemElement).dxCtrlTextBox({
                    value: objet.data.nom,
                    label: "Nom article",
                    placeholder: "Nom de l'article (affiché sur la facture)...",
                    labelMode: 'floating',
                    inputAttr: { autocomplete: 'test-autocomplete' },
                    onValueChanged: function (e) {
                        objet.data.nom = e.value;
                        mSave("nom");
                    }
                })
            },
            colSpanXs: 16, colSpanSm: 16, colSpanMd: 16, colSpanLg: 16
        }, {
            dataField: "commentaire", name: "commentaire", label: { visible: false, text: "Commentaire", location: "left" },
            template: function (itemData, itemElement) {
                $("<div/>").appendTo(itemElement).dxCtrlTextBox({
                    value: objet.data.commentaire,
                    label: "Commentaire article",
                    placeholder: "Commentaire de l'article...",
                    labelMode: 'floating',
                    maxLength: 4000,
                    multiline: true,
                    minHeight: 120,
                    inputAttr: { autocomplete: 'test-autocomplete' },
                    onValueChanged: function (e) {
                        objet.data.commentaire = e.value;
                        mSave("commentaire");
                    }
                })
            },
            colSpanXs: 16, colSpanSm: 16, colSpanMd: 16, colSpanLg: 16
        }]
        //[{
        //    dataField: "id_tva", name: "id_tva", label: { visible: false, text: "TVA", location: "left" },
        //    template: function (itemData, itemElement) {
        //        var $Table = $("<table/>").appendTo(itemElement)
        //        var $Tr = $("<tr/>").appendTo($Table)
        //        var $Td = $("<td style='width:100%'/>").appendTo($Tr)
        //        var dxCtrlTva = $("<div/>").appendTo($Td).dxSelectBox({
        //            labelMode: 'floating',
        //            label: "TVA",
        //            dataSource: Me.objet.bddRef.mGetArray("tva"),
        //            displayExpr: "nom",
        //            valueExpr: "id_tva",
        //            value: objet.data.id_tva,
        //            placeholder: "Choisissez le taux de TVA...",
        //            itemTemplate: function (itemData, itemIndex, itemElement) {
        //                itemElement.text(itemData.nom + " (" + parseFloat(itemData.taux) + "%)")
        //            },
        //            fieldTemplate(itemData, fieldElement) {
        //                $("<div/>").appendTo(fieldElement).dxTextBox({
        //                    value: ((itemData == null) ? "" : itemData.nom + " (" + parseFloat(itemData.taux) + "%)"),
        //                    readOnly: true,
        //                    disabled: true
        //                });
        //            },
        //            onValueChanged: function (e) {
        //                if (inMaj) return;
        //                objet.data.id_tva = e.value;
        //                var puht = parseFloat(objet.data.puht)
        //                inMaj = true
        //                dxPuTTC.option("value", Me.mGetPUTTC())
        //                window.setTimeout(function () { inMaj = false }, 500)
        //                mSave();
        //            }
        //        }).dxSelectBox("instance");
        //        Me.objet.bddRef.mAddFunctionOnModifiedItemData(["tva"], itemElement,
        //            function (action, itemData) {
        //                dxCtrlTva.option("dataSource", Me.objet.bddRef.mGetArray("tva"))
        //            })

        //        var $Td = $("<td style='width:1px'/>").appendTo($Tr)
        //        $("<div/>").appendTo($Td).dxCtrlButton({
        //            icon: 'fas fa-percent',
        //            icon2: "fas fa-certificate",
        //            colorIcone2: theme.colorBtIcon2,
        //            opacityIcone2: "0.9",
        //            txtTooltip: "Créer un nouveau taux de tva",
        //            onClick: function (e) {
        //                Me.objet.bddRef.getObjet("tva").objetMetier.mShowPopupTva(Me.objet.bddRef.getObjet("tva").mGetNewData());
        //            }
        //        })
        //    },
        //    colSpanXs: 16, colSpanSm: 16, colSpanMd: 16, colSpanLg: 16
        //}, {
        //    name: "puttc", label: { visible: false, text: "Prix unitaire TTC", location: "left" },
        //    template: function (itemData, itemElement) {
        //        var $Table = $("<table style='width:100%'/>").appendTo(itemElement)
        //        var $Tr = $("<tr/>").appendTo($Table)
        //        var $Td = $("<td style='width:50%;padding-right:5px;'/>").appendTo($Tr)
        //        dxPuHT = $("<div/>").appendTo($Td).dxCtrlNumberBox({
        //            labelMode: 'floating',
        //            label: "Prix unitaire HT",
        //            isFloat: true,
        //            noNull: true,
        //            value: objet.data.puht,
        //            format: '#0.0000',
        //            inputAttr: { 'aria-label': 'Fixed Point Format' },
        //            placeholder: "Saisissez le prix unitaire HT...",
        //            onValueChanged: function (e) {
        //                if (inMaj) return;
        //                objet.data.puht = e.value;
        //                var puht = parseFloat(objet.data.puht)
        //                inMaj = true
        //                dxPuTTC.option("value", Me.mGetPUTTC())
        //                inMaj = false
        //                mSave();
        //            }
        //        }).dxCtrlNumberBox("instance");
        //        var $Td = $("<td style='width:50%;'/>").appendTo($Tr)
        //        dxPuTTC = $("<div/>").appendTo($Td).dxCtrlNumberBox({
        //            labelMode: 'floating',
        //            label: "Prix unitaire TTC",
        //            isFloat: true,
        //            noNull: true,
        //            value: Me.mGetPUTTC(),
        //            placeholder: "Saisissez le prix unitaire TTC...",
        //            onValueChanged: function (e) {
        //                if (inMaj) return;
        //                inMaj = true
        //                var puHT = Math.round(e.value / (1 + Me.objet.bddRef.getObjet(objet.data).objetMetier.mGetTauxTva() / 100) * 10000) / 10000
        //                objet.data.puht = puHT
        //                dxPuHT.option("value", puHT)
        //                window.setTimeout(function () { inMaj = false }, 500)
        //                mSave();
        //            }
        //        }).dxCtrlNumberBox("instance")

        //        $("<div/>").appendTo(itemElement).dxCheckBox({
        //            value:(objet.data.has_tarif_date=="1")
        //        })
        //    },
        //    colSpanXs: 16, colSpanSm: 16, colSpanMd: 16, colSpanLg: 16
        //}, {
        //    name: "plan_comptable", label: { visible: false, text: "Plan comptable", location: "left" },
        //    template: function (itemData, itemElement) {
        //        $("<div/>").appendTo(itemElement).dxCtrlPlanComptable({
        //            bddCtrl: Me.objet.bddRef,
        //            value: objet.data.plan_comptable,
        //            onValueChanged: function (e) {
        //                objet.data.plan_comptable = e.value;
        //                mSave("plan_comptable");
        //            }
        //        }).dxCtrlPlanComptable("instance")
        //    },
        //    colSpanXs: 16, colSpanSm: 16, colSpanMd: 16, colSpanLg: 16
        //}, {
        //    dataField: "abandon", name: "abandon", label: { visible: false, text: "Article abandonné", location: "left" },
        //    template: function (itemData, itemElement) {
        //        $("<div/>").appendTo(itemElement).dxCheckBox({
        //            labelMode: 'floating',
        //            label: "Article abandonné",
        //            text: "Abandonné",
        //            value: (objet.data.abandon == "1"),
        //            onValueChanged: function (e) {
        //                objet.data.abandon = ((e.value) ? "1" : "0")
        //                mSave(itemData.dataField);
        //            }
        //        });
        //    },
        //    colSpanXs: 16, colSpanSm: 16, colSpanMd: 16, colSpanLg: 16
        //}]

        items.push({
            itemType: "group", name: "grpimg",
            caption: "",
            items: itemsAdr,
            colSpanXs: 10, colSpanSm: 10, colSpanMd: 10, colSpanLg: 10
        })

        items.push({
            dataField: "id_tva", name: "id_tva", label: { visible: false, text: "TVA", location: "left" },
            template: function (itemData, itemElement) {
                var $Table = $("<table/>").appendTo(itemElement)
                var $Tr = $("<tr/>").appendTo($Table)
                var $Td = $("<td style='width:100%'/>").appendTo($Tr)
                var dxCtrlTva = $("<div/>").appendTo($Td).dxSelectBox({
                    labelMode: 'floating',
                    label: "TVA",
                    dataSource: Me.objet.bddRef.mGetArray("tva"),
                    displayExpr: "nom",
                    valueExpr: "id_tva",
                    value: objet.data.id_tva,
                    placeholder: "Choisissez le taux de TVA...",
                    itemTemplate: function (itemData, itemIndex, itemElement) {
                        itemElement.text(itemData.nom + " (" + parseFloat(itemData.taux) + "%)")
                    },
                    fieldTemplate(itemData, fieldElement) {
                        $("<div/>").appendTo(fieldElement).dxTextBox({
                            value: ((itemData == null) ? "" : itemData.nom + " (" + parseFloat(itemData.taux) + "%)"),
                            readOnly: true,
                            disabled: true
                        });
                    },
                    onValueChanged: function (e) {
                        if (inMaj) return;
                        objet.data.id_tva = e.value;
                        //var puht = parseFloat(objet.data.puht)
                        //inMaj = true
                        //dxPuTTC.option("value", Me.mGetPUTTC())
                        window.setTimeout(function () { inMaj = false }, 500)
                        mSave();
                        mRempliTarif()
                    }
                }).dxSelectBox("instance");
                Me.objet.bddRef.mAddFunctionOnModifiedItemData(["tva"], itemElement,
                    function (action, itemData) {
                        dxCtrlTva.option("dataSource", Me.objet.bddRef.mGetArray("tva"))
                    })

                var $Td = $("<td style='width:1px'/>").appendTo($Tr)
                $("<div/>").appendTo($Td).dxCtrlButton({
                    icon: 'fas fa-percent',
                    icon2: "fas fa-certificate",
                    colorIcone2: theme.colorBtIcon2,
                    opacityIcone2: "0.9",
                    txtTooltip: "Créer un nouveau taux de tva",
                    onClick: function (e) {
                        Me.objet.bddRef.getObjet("tva").objetMetier.mShowPopupTva(Me.objet.bddRef.getObjet("tva").mGetNewData());
                    }
                })
            },
            colSpanXs: 16, colSpanSm: 16, colSpanMd: 16, colSpanLg: 16
        })
        var mRempliTarif = null
        var inMaj = false
        items.push({
            name: "puttc", label: { visible: false, text: "Prix unitaire TTC", location: "left" },
            template: function (itemData, itemElement) {
                mRempliTarif = function mRempli() {
                    itemElement.empty()
                    itemElement.css("padding", "10px 10%")
                    if (objet.data.has_date_tarif == "0") {
                        var $Table = $("<table style='width:100%'/>").appendTo(itemElement)
                        var $Tr = $("<tr/>").appendTo($Table)
                        var $Td = $("<td style='width:50%;padding-right:5px;'/>").appendTo($Tr)
                        var dxPuHT = $("<div/>").appendTo($Td).dxCtrlNumberBox({
                            labelMode: 'floating',
                            label: "Prix unitaire HT",
                            isFloat: true,
                            noNull: true,
                            value: objet.data.puht,
                            format: '#0.0000',
                            inputAttr: { 'aria-label': 'Fixed Point Format' },
                            placeholder: "Saisissez le prix unitaire HT...",
                            onValueChanged: function (e) {
                                if (inMaj) return;
                                objet.data.puht = e.value;
                                var puht = parseFloat(objet.data.puht)
                                inMaj = true
                                dxPuTTC.option("value", Me.mGetPUTTC())
                                window.setTimeout(function () { inMaj = false }, 500)
                                mSave();
                            }
                        }).dxCtrlNumberBox("instance");
                        var $Td = $("<td style='width:50%;'/>").appendTo($Tr)
                        var dxPuTTC = $("<div/>").appendTo($Td).dxCtrlNumberBox({
                            labelMode: 'floating',
                            label: "Prix unitaire TTC",
                            isFloat: true,
                            noNull: true,
                            value: Me.mGetPUTTC(),
                            placeholder: "Saisissez le prix unitaire TTC...",
                            onValueChanged: function (e) {
                                if (inMaj) return;
                                inMaj = true
                                var puHT = Math.round(e.value / (1 + Me.objet.bddRef.getObjet(objet.data).objetMetier.mGetTauxTva() / 100) * 10000) / 10000
                                objet.data.puht = puHT
                                dxPuHT.option("value", puHT)
                                window.setTimeout(function () { inMaj = false }, 500)
                                mSave();
                            }
                        }).dxCtrlNumberBox("instance")
                    } else {
                        $("<div/>").appendTo(itemElement).dxCtrlArticleDateTarif({
                            bddCtrl: objet.bddRef,
                            dataArticle: objet.data
                        })
                    }
                    $("<div style='margin:15px;'/>").appendTo(itemElement).dxCheckBox({
                        text: "Utiliser des dates de tarif",
                        value: (objet.data.has_date_tarif == "1"),
                        onValueChanged: function (e) {
                            objet.data.has_date_tarif = (e.value ? "1" : "0")
                            mSave();
                            mRempliTarif()
                        }
                    })
                }
                mRempliTarif()
            },
            colSpanXs: 16, colSpanSm: 16, colSpanMd: 16, colSpanLg: 16
        })
        items.push({
            name: "plan_comptable", label: { visible: false, text: "Plan comptable", location: "left" },
            template: function (itemData, itemElement) {
                $("<div/>").appendTo(itemElement).dxCtrlPlanComptable({
                    bddCtrl: Me.objet.bddRef,
                    value: objet.data.plan_comptable,
                    onValueChanged: function (e) {
                        objet.data.plan_comptable = e.value;
                        mSave("plan_comptable");
                    }
                }).dxCtrlPlanComptable("instance")
            },
            colSpanXs: 16, colSpanSm: 16, colSpanMd: 16, colSpanLg: 16
        })
        items.push({
            dataField: "abandon", name: "abandon", label: { visible: false, text: "Article abandonné", location: "left" },
            template: function (itemData, itemElement) {
                $("<div/>").appendTo(itemElement).dxCheckBox({
                    labelMode: 'floating',
                    label: "Article abandonné",
                    text: "Abandonné",
                    value: (objet.data.abandon == "1"),
                    onValueChanged: function (e) {
                        objet.data.abandon = ((e.value) ? "1" : "0")
                        mSave(itemData.dataField);
                    }
                });
            },
            colSpanXs: 16, colSpanSm: 16, colSpanMd: 16, colSpanLg: 16
        })

        contentElement.css({ "text-align": "center" })
        var $Div = $("<div style='max-width:500px;width:100%;text-align:left;display:inline-block;'/>").appendTo(dxScroll.content())
        var form = $("<div/>").appendTo($Div).dxCtrlForm({
            labelMode: 'floating',
            showColonAfterLabel: true,
            labelLocation: 'left',
            formData: objet.data,
            items: items
        }).dxCtrlForm("instance");

        if (Me.objet.bddRef.mGetArray("societe").filter(function (soc) { return soc.assujetti_tva == 0 }).length > 0) {
            //on a des sociétés non assujetti à la TVA
            //on met un message de signalement
            $("<div style='font-style:italic;color:orange;'>Pour les sociétés non assujetti à la TVA, seul le prix TTC est prix en compte (il sera considéré comme hors taxe).</div>").appendTo($Div)
        }

        var inSaveWithIdNull = false;
        function mSave(dataField) {
            if (typeof dataField == 'undefined' || dataField.length == 0) { objet.mSave(); }
            else {
                if (inSaveWithIdNull) {
                    window.setTimeout(function () { mSave(dataField); }, 100);
                } else {
                    inSaveWithIdNull = (objet.cle() == null)
                    objet.mSaveChamp(dataField, function () { inSaveWithIdNull = false; });
                }
            }
        }

        if (objet.data.id_article != null) {
            $("<div/>").appendTo($Div).dxCtrlChartArticle({
                bddCtrl: Me.objet.bddRef,
                lst_id_article: [objet.data.id_article]
            })
        }

    }

    this.mGetNomFromTemplate = function (dataTemplate) {
        return dataTemplate.nom
    }
    this.itemTemplateGrille = function (contentElement, dataTemplate, type, option) {
        var $Table = $("<table style='table-layout:fixed;width:100%;'/>").appendTo(contentElement)
        var $Tr = $("<tr/>").appendTo($Table)

        var $TdImg = $("<td style='width:30px;padding:0 3px;height:1px;'/>").appendTo($Tr)
        $("<div style='width:100%;height:100%;display:inline-table;'/>").appendTo($TdImg).dxCtrlImgStrConUti({
            bddCtrl: objet.bddRef,
            idTable: dataTemplate.id_table_key,
            id: dataTemplate.id_key,
            text: "",
            allowClickImage: false,
            hideText: true,
            hideIcone: false,
            onContentReady: function (component) {
                component.element().find(".image").css("vertical-align", "top") //pour edge
                component.element().find(".image").css("display", "inline-table") //pour firefox
                component.element().find(".image").css("border-radius", "0")
                component.element().find(".image").css("background-color", "rgba(191, 191, 191, 0.1)")
                component.element().find(".icone").css("opacity", "0.5")

            }
        })

        var $TdUti = $("<td style='width:30px;padding:0 3px;height:1px;'/>").appendTo($Tr)
        $("<div style='width:100%;height:100%;border-radius:50%;'/>").appendTo($TdUti).dxCtrlImgSimpleStrConUti({
            bddCtrl: objet.bddRef,
            idTable: objet.bddRef.getObjet("utilisateur").mGetTable().id_table,
            id: dataTemplate.id_utilisateur,
            text: ((dataTemplate.id_utilisateur == null) ? "" : objet.bddRef.getObjet("utilisateur", dataTemplate.id_utilisateur).mGetLib1())
        })

        var lib = ((dataTemplate.nom == null) ? "" : dataTemplate.nom)
        if (dataTemplate.commentaire != null && dataTemplate.commentaire.length > 0) {
            lib += " &bull; <span style='opacity:0.4'><i>" + dataTemplate.commentaire + "</i></span>"
        }
        if (type == "Lignes") {
            var $TdLibDest = $("<td style='width:100%;padding:0 3px;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;'>" + lib + "</td>").appendTo($Tr)
        } else {
            var $TrDetail = $("<tr/>").appendTo($Table)
            var $TdLibDest = $("<td style='width:100%;padding:0 3px;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;' colspan='5'>" + lib + "</td>").appendTo($TrDetail)
        }


        var $TdHt = $("<td style='overflow:hidden;text-overflow:ellipsis;padding:0 3px;width:105px;text-align:right;position:relative;'><span class='dx-field-item-label-text' style='font-size:50%;position:absolute;right:2px;top:-7px;'>PUHT:</span>" + parseFloat(dataTemplate.puht).formatDisplay(4) + "€</td>").appendTo($Tr).attr("title", "Prix unitaire HT<br>" + parseFloat(dataTemplate.puht).formatDisplay(4))
        if (type == "Détails") { $TdHt.css("width", "100%") }
        var $TdTva = $("<td style='overflow:hidden;text-overflow:ellipsis;padding:0 3px;width:105px;text-align:right;position:relative;'><span class='dx-field-item-label-text' style='font-size:50%;position:absolute;right:2px;top:-7px;'>TVA:</span>" + parseFloat(dataTemplate.taux_tva).formatDisplay() + "%</td>").appendTo($Tr).attr("title", "Taux TVA<br>" + parseFloat(dataTemplate.taux_tva).formatDisplay())
        var $TdTtc = $("<td style='overflow:hidden;text-overflow:ellipsis;padding:0 3px;width:105px;text-align:right;position:relative;'><span class='dx-field-item-label-text' style='font-size:50%;position:absolute;right:2px;top:-7px;'>PUTTC:</span>" + parseFloat(dataTemplate.puht + dataTemplate.puht * dataTemplate.taux_tva / 100).formatDisplay() + "€</td>").appendTo($Tr).attr("title", "Prix unitaire TTC<br>" + parseFloat(dataTemplate.puht + dataTemplate.puht * dataTemplate.taux_tva / 100).formatDisplay())
    }
    this.itemTemplateGrillePlus = function (contentElement, dataPlus) {
        $("<span style='' title='Créé le " + dataPlus.dcr.toFrenchDateTime() + "'><i class='fas fa-certificate dx-theme-accent-as-text-color' style='padding-right:3px;'></i>" + dataPlus.dcr.toDateIlya(true) + "</span>").appendTo(contentElement)
    }

    this.mGetPUHT = function (dat) {
        if (objet.data.has_date_tarif == "0") {
            return objet.data.puht
        } else {
            var dataTarifDate = this.mGetLstTarifDate(dat)
            if (dataTarifDate) {
                return dataTarifDate.puht || 0
            } else {
                return objet.data.puht
            }
        }
    }

    this.mGetLstTarifDate = function (dat) {
        if (!dat) dat = parametre.dateNow

        var lstTarifDate = objet.bddRef.mGetArray("article_date_tarif")
            .filter(function (o) {
                return o.id_article == objet.data.id_article
            })
            .sort(function (o1, o2) {
                return o2.date_fin - o1.date_fin
            })

        // Tarif actif
        var dataTarifDate = lstTarifDate.filter(function (o) {
            return dat >= o.date_debut && dat <= o.date_fin
        })[0]

        if (dataTarifDate) return dataTarifDate

        // Tarif précédent le plus proche
        dataTarifDate = lstTarifDate.filter(function (o) {
            return o.date_fin < dat
        })[0]

        // Aucun tarif précédent : prendre le premier tarif futur
        if (!dataTarifDate && lstTarifDate.length > 0) {
            dataTarifDate = lstTarifDate[lstTarifDate.length - 1]
        }

        return dataTarifDate
    }

    this.mGetPUTTC = function (dat) {
        var puht = this.mGetPUHT(dat)
        return Math.round((parseFloat(puht) + parseFloat(puht) * this.mGetTauxTva() / 100) * 100) / 100
    }

    this.mGetDataTva = function () {
        return Me.objet.bddRef.mGetArray("tva").filter(function (o) { return o.id_tva == objet.data.id_tva })[0]
    }

    this.mGetTauxTva = function () {
        var dataTva = this.mGetDataTva()
        if (typeof dataTva == 'undefined') {
            return 0
        } else {
            return Me.objet.bddRef.getObjet(dataTva).objetMetier.mGetTauxTva()
        }
    }

    this.mGetLibMultiQteForLigneDocCpt = function (dataDocCptLigne) {
        var txt = ""
        objet.bddRef.mGetArray("article_qte").filter(function (o) { return o.id_article == objet.data.id_article }).forEach(function (dataArtQte, idx) {
            if (txt.length > 0) txt += " × "
            txt += dataDocCptLigne["qte" + (idx + 1)] + " " + dataArtQte.nom + (dataDocCptLigne["qte" + (idx + 1)] > 1 ? "s" : "")
        })
        return txt
    }

}